import {Injectable} from '@nestjs/common';
import { TypesOfLeaves } from '../types-of-leaves.entity';
import { TypesOfLeavesDTO } from './types-of-leaves.dto';

@Injectable()
export class TypesOfLeavesAdapter {
    /**
     * 
     * @param typesOfLeavesDTO 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( typesOfLeavesDTO: TypesOfLeavesDTO, isUpdate: boolean = false): TypesOfLeaves {
        const entityObj = new TypesOfLeaves();
        entityObj.typeOfLeaveId=typesOfLeavesDTO.typeOfLeaveId;
        entityObj.typeOfLeave=typesOfLeavesDTO.typeOfLeave;
        entityObj.leaveCode=typesOfLeavesDTO.leaveCode;
        entityObj.defaultLeaves=typesOfLeavesDTO.defaultLeaves;
       
        entityObj.isActive=typesOfLeavesDTO.isActive==undefined?true:typesOfLeavesDTO.isActive;
        if (isUpdate){
            entityObj.updatedUser = typesOfLeavesDTO.updatedUser;
        }else {
            entityObj.isActive = true;
            entityObj.createdUser=typesOfLeavesDTO.createdUser;
        }
        return entityObj;
    }
    public convertEntityToDto( data: TypesOfLeaves): TypesOfLeavesDTO{
        const typesOfLeavesDTO = new TypesOfLeavesDTO;
        typesOfLeavesDTO.typeOfLeaveId=data.typeOfLeaveId;
        typesOfLeavesDTO.typeOfLeave=data.typeOfLeave;
        typesOfLeavesDTO.leaveCode=data.leaveCode;
        typesOfLeavesDTO.defaultLeaves=data.defaultLeaves;
        typesOfLeavesDTO.isActive=data.isActive;
        typesOfLeavesDTO.createdAt=data.createdAt;
        typesOfLeavesDTO.createdUser=data.createdUser;
        typesOfLeavesDTO.updatedAt=data.updatedAt;
        typesOfLeavesDTO.updatedUser=data.updatedUser;
        typesOfLeavesDTO.versionFlag=data.versionFlag;
        return typesOfLeavesDTO;
    }
}